import React from 'react';
import { Modal, Button, Row, Input, Radio, Select } from 'antd';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import ButtonClose from '../../../common/UI/ButtonClose';

import { validateApiKey } from '../../../../utils/validateApiKey';

import styles from './sectionEditModal.less';

const RadioGroup = Radio.Group;

class SectionCreateModal extends React.PureComponent {
    constructor(props) {
        super(props);
        this.inputRef = React.createRef();
        this.state = {
            name: this.props.name,
            rights: this.props.rights,
            id: this.props.id || '',
            idError: '',
        };
    }

    componentDidMount() {
        setTimeout(() => this.inputRef.current && this.inputRef.current.focus(), 10);
    }

    onChange = (e) => this.setState({ [e.target.name]: e.target.value });

    isValid() {
        if (this.state.idError) return false;

        return !!this.state.name;
    }

    onSave = (e) => {
        e.preventDefault();
        if (!this.isValid()) {
            return;
        }

        const normalizedName = (this.state.name).trim();

        this.props.onOk({
            name: normalizedName,
            rights: this.state.rights,
            id: this.state.id,
        });
    };

    onSelectRights = (e) => {
        this.setState({ rights: e.target.value });
    };

    onChangeId = (e) => {
        const value = e.target?.value;
        const originalId = this.props.id ? String(this.props.id) : '';
        const isSameAsOriginal = String(value || '') === originalId;
        const error = isSameAsOriginal ? '' : validateApiKey(value, this.props.t);
        this.setState({ id: value, idError: error });
    };

    render() {
        const { t, isNew } = this.props;

        return (
            <Modal
                open
                className={styles.modal}
                maskClosable={false}
                closable={false}
                width="50%"
                footer={[
                    <Button key="submit" type="primary" disabled={!this.isValid()} onClick={this.onSave}>
                        {isNew ? t('buttons.create') : t('buttons.save')}
                    </Button>,
                    <Button key="back" type="default" onClick={this.props.onCancel}>
                        {t('buttons.cancel')}
                    </Button>,
                ]}
            >
                <Row type="flex" justify="space-between" align="top" className={styles.modalHeader}>
                    <div>
                        <h2>
                            {isNew ? t('modals.createSection.headerText') : t('modals.changeSectionName.headerText')}
                            <br />
                        </h2>
                    </div>
                    <ButtonClose large shiftRight onClick={this.props.onCancel} />
                </Row>
                <div className={styles.modalBody}>
                    <form onSubmit={this.onSave}>

                        <div>
                            <label className={styles.label}>
                                <span className={styles.labelText}>{t('modals.createSection.inputPlaceHolder')}</span>
                                &nbsp;
                                <span className={styles.requiredFieldAsterisk}>*</span>
                                <Input name="name" required value={this.state.name} ref={this.inputRef} onChange={this.onChange} />
                            </label>
                        </div>

                        <div className={styles.labelsWrapper}>
                            <label className={styles.label}>
                                <span className={styles.labelText}>{t('modals.apiKeys.label')}</span>
                                <br />
                                <Input
                                    value={this.state.id}
                                    style={{ width: 220 }}
                                    onChange={this.onChangeId}
                                />
                                {this.state.idError ? (
                                    <span className={styles.error}>{t('modals.apiKeys.promptHint')}</span>
                                ) : (
                                    <span className={styles.hint}>{t('modals.apiKeys.hintEmpty')}</span>
                                )}
                            </label>
                        </div>

                        {isNew && (
                            <div className={styles.labelsWrapper}>
                                <span className={styles.labelText}>{t('modals.createSection.labelForRights')}</span>
                                <br />
                                <RadioGroup onChange={this.onSelectRights} value={this.state.rights || 'all'}>
                                    <Radio className={styles.radioButton} value="all">
                                        {t('modals.createSection.labelForRightsAll')}
                                    </Radio>
                                    <Radio className={styles.radioButton} value="me">
                                        {t('modals.createSection.labelForRightsMe')}
                                    </Radio>
                                    <Radio className={styles.radioButton} value="set">
                                        {t('modals.createSection.labelForRightsSet')}
                                    </Radio>
                                </RadioGroup>
                            </div>
                        )}
                    </form>
                </div>
            </Modal>
        );
    }
}

SectionCreateModal.propTypes = {
    name: PropTypes.string,
    id: PropTypes.string,
    rights: PropTypes.string,
    isNew: PropTypes.bool,
    onOk: PropTypes.func.isRequired,
    onCancel: PropTypes.func,
    okText: PropTypes.string,
};

export default withTranslation()(SectionCreateModal);
